import store from "@/store";

function handleGameStatus(el, binding) {
  if (!el) {
    return;
  }
  
  const games = store.getters.getGamesList;
  
  if (binding.value && games[binding.value] && !games[binding.value].active) {
    
    el.classList?.add('disabled-game');
    
    el.clickHandler = (event) => {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
      
      store.dispatch("showAlertDialog", {
        title: "Game Unavailable",
        text: "This game is currently unavailable. Please try again later.",
        permanent: true,
      });
    };
    
    el.addEventListener('click', el.clickHandler, true);
  } else {
    el.classList?.remove('disabled-game');
    
    if (el.clickHandler) {
      el.removeEventListener('click', el.clickHandler, true);
    }
  }
}

export default {
  inserted(el, binding) {
    el._storeWatcher = store.watch(
      (state) => state.gamesList,
      () => {
        handleGameStatus(el, binding);
      },
      { deep: true, immediate: true }
    );
  },
  unbind(el) {
    if (el.clickHandler) {
      el.removeEventListener('click', el.clickHandler);
    }
    
    if (el._storeWatcher) {
      el._storeWatcher(); // Stop watching the `gamesList` property
    }
  },
}